import React from "react";

const PrivacyStatement = (props) => (
    <div className="container">
        <h2>Datenschutz</h2>
        <div className="row">
            <div className="col-sm-12">
                <p><strong>Datenschutzerklärung</strong></p>
                <p>Diese Erklärung erfolgt im Rahmen der Datenschutzgrundverordnung (DSGVO), in der über diese Erklärung
                    hinausgehend weitere Rechte, Pflichten u.a. festgelegt sind. Zur besseren Lesbarkeit fasst diese
                    Erklärung die wichtigsten Grundsätze übersichtlich in folgenden Abschnitten zusammen</p>
                <p>Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf
                    unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben
                    werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre
                    ausdrückliche Zustimmung nicht an Dritte weitergegeben.</p>
                <p>Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail)
                    Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist
                    nicht möglich.</p>
                <p><strong>Cookies</strong></p>
                <p>Wir verwenden keine Cookies auf den Seiten der SIB GmbH</p>
                <p><strong>Auskunft, Löschung, Sperrung</strong></p>
                <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen
                    Daten,
                    deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung,
                    Sperrung
                    oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können
                    Sie sich
                    jederzeit unter der im Impressum angegebenen Adresse an uns wenden.</p>
                <p><strong>Datenschutz-Grundsätze</strong></p>
                <p>Das Persönlichkeitsrecht auf informelle Selbstbestimmung wird durch Rechtsvorschriften - z.B. das
                    Telemediengesetz und das Bundesdatenschutzgesetz - vom Gesetzgeber geschützt. Selbstverständlich
                    steht unser Internet-Auftritt im Einklang mit den gesetzlichen Datenschutzbestimmungen. Wir gehen
                    aber aufgrund unserer besonderen Verpflichtung in einigen Punkten darüber hinaus:</p>
                <ul>
                    <li>Sie können sich auf unseren Internetseiten anonym bewegen</li>
                    <li>Die Stellen, an denen persönliche Daten erhoben werden, sind klar gekennzeichnet</li>
                    <li>Sie entscheiden, welche persönlichen Daten wir erhalten</li>
                    <li>Die MitarbeiterInnen der SIB GmbH haben Verschwiegenheitspflichten zu wahren</li>
                    <li>Die Sicherheitssysteme auf unserem Server entsprechen dem aktuellen Stand der Technik</li>
                    <li>Sie haben ein Auskunftsrecht über die von Ihnen bei uns gespeicherten Daten</li>
                    <li>Sofern keine gesetzliche Verpflichtung zur Datenübermittlung besteht, geben wir Ihre Daten nur
                        durch ausdrückliche Aufforderung durch Sie an Dritte außerhalb der SIB GmbH weiter
                    </li>
                </ul>
                <p>Im Rahmen der Auswertung unseres Internetauftrittes und zur kontinuierlichen Verbesserung unserer
                    Webseite sammeln wir statistische Informationen. Dies sind z.B. Besucherzahl, Seitenaufrufe,
                    demografische Angaben, Browsertyp, Zugriffsdatum und -uhrzeit und ähnliche Daten. Diese
                    Informationen haben keinen Personenbezug.</p>
            </div>
        </div>
    </div>
)

export default PrivacyStatement;



// WEBPACK FOOTER //
// ./src/privacystatement/privacystatement.js